<template>
  <div id="drugrighttwo">
    <div class="eare">
      <div class="eareItem" v-for="(item, index) in echartsList" :key="index">
        <el-image
          style="width: 100px; height: 100px"
          :src="imgURL + item.fileUrl"
          :preview-src-list="srcList"
          :initial-index="4"
          fit="cover"
        >
        </el-image>
        <div class="moreBtn" @click="moreClick">
          <div class="moreSelect" v-show="moreFalse">
            <div class="moreList">
              <i :class="['iconfont', 'icon-jurassic_safe']"></i>
              重点人员
            </div>
            <div class="moreList">
              <i :class="['iconfont', 'icon-jurassic_safe']"></i>
              重点人员
            </div>
          </div>
        </div>
        <div class="eareFont">
          <div class="bluebg"></div>
          {{ item.personName }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  watchEffect,
  inject,
  nextTick,
  // watch // watch([()=>data.要监听的属性,...监听多个属性],(newValue,oldValue)=>{})
} from "vue";
import { oftenOut } from "@/api/publicSecurityResearch/drugControlModel.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      imgURL: window.imgURL,
      srcList: [],
      echartsList: [],
      moreFalse: false,
      url: "",
    });
    const refData = toRefs(data);
    const ruleInfo = inject("ruleInfo");
    watchEffect(() => {
      if (ruleInfo.endDate || ruleInfo.startDate || ruleInfo.threshold) {
        nextTick(() => {
          numberall();
        });
      }
    });
    const numberall = async () => {
      const parms = {
        endDate: ruleInfo.endDate,
        startDate: ruleInfo.startDate,
        threshold: ruleInfo.threshold,
      };
      const res = await oftenOut(parms);
      const list = res.page.list;
      data.echartsList = list.splice(0, 3);
    };
    onMounted(() => {});
    return { ...refData, numberall };
  },
});
</script>
<style lang="scss" scoped>
#drugrighttwo {
  width: 100%;
  height: 90%;
  .eare {
    display: flex;
    margin: 20px 0;
    justify-content: space-evenly;
    .eareItem {
      display: flex;
      flex-direction: column;
      position: relative;
      .eareFont {
        display: flex;
        align-items: center;
        margin-top: 6px;
        .bluebg {
          width: 5px;
          height: 5px;
          margin-right: 10px;
          background-color: #73f1f3;
        }
      }
      .moreBtn {
        position: absolute;
        width: 100%;
        text-align: center;
        background: rgba(0, 0, 0, 0.5);
        bottom: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
